import { render, staticRenderFns } from "./ManageAuthenticationView.vue?vue&type=template&id=7710f29a&scoped=true&"
import script from "./ManageAuthenticationView.vue?vue&type=script&lang=js&"
export * from "./ManageAuthenticationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7710f29a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7710f29a')) {
      api.createRecord('7710f29a', component.options)
    } else {
      api.reload('7710f29a', component.options)
    }
    module.hot.accept("./ManageAuthenticationView.vue?vue&type=template&id=7710f29a&scoped=true&", function () {
      api.rerender('7710f29a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/email/ManageAuthenticationView.vue"
export default component.exports